module.exports = __webpack_public_path__ + "img/1.700d1ec8.png";